var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2983",
    "data-name": "Rectangle 2983",
    width: 20,
    height: 18,
    transform: "translate(0 0.001)",
    fill: "#313a41"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10635",
    "data-name": "Group 10635",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10634",
    "data-name": "Group 10634",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28433",
    "data-name": "Path 28433",
    d: "M15.8,18H4.041a.735.735,0,0,1-.735-.735V13.959H.735A.735.735,0,0,1,0,13.224V5.878a2.27,2.27,0,0,1,2.327-2.2h.98V.735A.735.735,0,0,1,4.041,0H15.8a.735.735,0,0,1,.735.735V3.673h.98a2.27,2.27,0,0,1,2.327,2.2v7.347a.735.735,0,0,1-.735.735H16.531v3.306A.735.735,0,0,1,15.8,18M4.776,16.531H15.061V11.755H4.776ZM16.531,12.49h1.837V5.878a.8.8,0,0,0-.857-.735H2.327a.8.8,0,0,0-.857.735V12.49H3.306V11.02a.735.735,0,0,1,.735-.735H15.8a.735.735,0,0,1,.735.735ZM4.776,3.673H15.061v-2.2H4.776Z",
    fill: "#313a41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28434",
    "data-name": "Path 28434",
    d: "M119.208,55.1a1.1,1.1,0,1,1-1.1-1.1,1.1,1.1,0,0,1,1.1,1.1",
    transform: "translate(-102.677 -47.388)",
    fill: "#313a41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/Print_icon.ffb2d8805389c94b7bd6fa5b19576aff.svg";
export { ForwardRef as ReactComponent };